import React from "react";
import Popup from "../common/Popup";
import QRCode from "react-qr-code";

const CohortCodePopup = ({ open, onClose, accessCode = "AAAAAA" }) => {
  return (
    <Popup
      open={open}
      onCancel={onClose}
      onOk={onClose}
      footer={null}
      width={680}
      content={
        <div className="p-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold mb-6">Cohort Access Code</h2>

            <div className="text-6xl font-bold text-indigo-600 mb-4">
              {accessCode}
            </div>
            <p className="text-gray-600">
              Join at app.dittrium.com/join or scan the QR Code
            </p>
          </div>
          <div className="w-36 h-36 bg-gray-300">
            <QRCode className="w-full h-full" value={`https://app.dittrium.com/join?code=${accessCode}`} />
          </div>
        </div>
      }
    />
  );
};

export default CohortCodePopup;
